import { processComponentOption, getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor";
var wxsModules = {};
global.currentModuleId = "_2c8c38ed";
global.currentSrcMode = "wx";
global.currentInject = { "moduleId": "_2c8c38ed" };
/** script content **/
require("./cascade-picker-popup.ts?ctorType=component&index=0&isComponent&lang=ts&mpx&outputPath=components%2Findex2c8c38ed%2Findex&resourcePath=%2Fhome%2Frunner%2Fwork%2Fmpx-cube-ui%2Fmpx-cube-ui%2Fpackages%2Fmpx-cube-ui%2Fsrc%2Fcomponents%2Fcascade-picker-popup%2Findex.mpx&type=script");
export default processComponentOption({
    option: global.__mpxOptionsMap["_2c8c38ed"],
    ctorType: "component",
    outputPath: "components/index2c8c38ed/index",
    pageConfig: {},
    // @ts-ignore
    componentsMap: { 'cube-picker-popup-base': getComponent(require("../picker-popup/picker-popup-base.mpx?isComponent&outputPath=components%2Fpicker-popup-base146a305a%2Findex")), 'cube-cascade-picker': getComponent(require("../cascade-picker/index.mpx?isComponent&outputPath=components%2Findexb6a89be4%2Findex")) },
    componentGenerics: {},
    genericsInfo: undefined,
    wxsMixin: getWxsMixin(wxsModules),
    hasApp: true
});
